module.exports = __webpack_public_path__ + "img/IT0000100240817.47b3be05.png";